import Vue from 'vue';
import BzbsApi from "@/core/Http/BzbsApi.js";

/**
 * @function getFriendLink
 */
export default {
    getFriendLink: function(token) {
        var url = `${Vue.bzbsConfig.bzbsUrl}/referral/link`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, null).then((res) => {
                resolve(res.data.link);
            }).catch((err) => {
                reject(err);
            });
        });
    },
}
